import cx from 'classnames';
import PropTypes from 'prop-types';

import { CustomTypography, TYPOGRAPHY_VARIANT } from 'src/components/CustomTypography';
import { TruncatedTooltip } from 'src/components/TruncatedTooltip';

import { useStyles } from './useStyles';

export { TYPOGRAPHY_VARIANT }; // re-exporting for convenience

export const TruncatedTypography = ({
  className,
  classes,
  children,
  title,
  variant,
  hideTooltip,
  multiline,
  maxLines,
  ...restProps
}) => {
  const styles = useStyles({ classes });

  return (
    <TruncatedTooltip
      title={hideTooltip ? '' : title || children}
      className={styles.tooltip}
      {...restProps}
    >
      {(ref) => (
        <CustomTypography
          className={cx(styles.root, className, {
            [styles.multiline]: multiline,
          })}
          style={maxLines > 0 ? { '--max-lines': maxLines } : undefined}
          ref={ref}
          variant={variant}
        >
          {children}
        </CustomTypography>
      )}
    </TruncatedTooltip>
  );
};

TruncatedTypography.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.shape({}),
  title: PropTypes.node,
  children: PropTypes.node.isRequired,
  variant: PropTypes.string,
  hideTooltip: PropTypes.bool,
  multiline: PropTypes.bool,
  maxLines: PropTypes.number,
};
TruncatedTypography.defaultProps = {
  className: '',
  classes: null,
  title: null,
  variant: undefined,
  hideTooltip: false,
  multiline: false,
  maxLines: null,
};
